import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; 
import { HelmetProvider } from 'react-helmet-async'; // 1. Importación agregada
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider> {/* 2. HelmetProvider envolviendo todo */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('debugVitals')) {
  window.__disdelWebVitals = [];
  reportWebVitals((metric) => {
    window.__disdelWebVitals.push({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      delta: metric.delta,
    });
  });
}
